import React from "react";

//MUI
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

//Types
import {
  WinFactorQuestionModel,
  WinFactorOptionModel,
} from "../../models/WinProbabilityFactorModel";

type Props = {
  index: number;
  question: WinFactorQuestionModel;
  option: WinFactorOptionModel;
};

const WinProbabilityFactorDetail = ({ index, question, option }: Props) => {
  return (
    <Box sx={{ marginBottom: "0.5em" }}>
      <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
        Q{index}. {question.questionName}
      </Typography>
      <Typography variant="body2" sx={{ textIndent: "1em" }}>
        A. {option?.optionDetails}
      </Typography>
    </Box>
  );
};

export default WinProbabilityFactorDetail;
